<template>
    <div id="notice">
        <headers :title='titles'></headers>
        <!-- <div class='div_p' v-if="!no_class">
            <p></p>
            <p>{{grade}}</p>
            <p @click='replace'>更换年级 <i class="icon-zhankai"></i></p>
        </div> -->
        <div class="title"
             v-if="!no_class">
            <div>
                <p></p>
                <p>{{grade}}</p>
                <p @click="replace">更换<em>年级</em></p>
                <p></p>
            </div>
        </div>
        <loadingS v-if='loading'></loadingS>
        <div class='content'
             v-else>
            <div class="no_resources"
                 v-if='no_resources'>
                <noResouse></noResouse>
            </div>
            <ul v-if='getlist.length'>
                <li v-for='(li,index) in getlist'>
                    <span>{{li.name}}</span>
                    <em @click='add(li,index)'
                        class="icon-jia-hao"></em>
                    <span id='plus'
                          v-show='li.total > 0'
                          class="total">{{li.total}}</span>
                    <i class="icon-jian-hao"
                       v-show='li.total > 0'
                       @click='reduce(li,index)'></i>
                </li>
            </ul>
        </div>
        <div class="wrap"
             v-if="no_class">
            <div class='no_class'>
                <i class="icon-shezhijiaocai"></i>
                <h3>您暂未设置年级</h3>
                <p>请先设置一下年级吧，设置过后才能布置作业</p>
                <div class='set'
                     @click='set'>设置年级</div>
            </div>
        </div>
        <div v-if="!no_class">
            <div class="bott"
                 v-if='znum == 0'>作业预览（{{znum}}）</div>
            <div class="bottom"
                 v-else
                 @click='preview'>作业预览（{{znum}}）</div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            titles: '速算作业',  //标题
            num: 0,
            znum: 0,
            user: [],
            no_class: false,
            no_resources: false,
            ddd: false,
            getlist: [],
            shu: [],
            users: {},
            grade_id: null,
            grade: '',  //年级
            loading: true
        }
    },
    components: {
        headers,
        noResouse,
        loadingS
    },
    created () {
        (async () => {
            let math_send_ok = localStorage.getItem('math_send_ok');
            if (math_send_ok == 1) {
                this.$router.go(-1);
                return false;
            }
            await this.get_grade()
        })();
    },
    computed: {
        id () {
            return this.$store.state.num || {};
        },
    },
    methods: {
        set () {
            this.$router.replace('/sx/quick/setclass')
        },
        goBack () {
            this.$router.go(-1)
        },
        add (li, index) {
            if (this.znum < 50) {
                li.total += 5
                this.znum += 5
                this.shu[index] = [li.type_id, li.total]
            } else {
                layer.tips('已经超出50道题，不能再添加试题了', 2);
            }
        },
        reduce (li, index) {
            if (li.total > 0) {
                li.total -= 5
                this.znum -= 5
                this.shu[index] = [li.type_id, li.total]
            }
        },
        replace () {
            this.$router.replace('/sx/quick/setclass?grade_id=' + this.grade_id)
        },
        preview () {
            let that = this
            let shua = []
            this.shu.forEach(function (v, i) {
                if (v != 'undefined' && v[1] != 0) {
                    shua.push(v)
                }
            })
            localStorage.setItem('shua', JSON.stringify(shua))
            this.$router.push('/sx/quick/preview/' + this.grade_id)
        },
        get_grade () {
            let that = this
            this.$http.post(API_URL_TASK_API + "/maths/send/quick/get_grade").then(res => {
                if (res.data.response === 'ok') {
                    let grade_id = res.data.data.grade_id
                    if (grade_id == 0) {
                        that.no_class = true
                        this.loading = false
                    } else {
                        that.no_class = false
                        if (grade_id == 1) {
                            that.grade = '小学一年级'
                            that.grade_id = 1
                        } else if (grade_id == 2) {
                            that.grade = '小学二年级'
                            that.grade_id = 2
                        } else if (grade_id == 3) {
                            that.grade = '小学三年级'
                            that.grade_id = 3
                        } else if (grade_id == 4) {
                            that.grade = '小学四年级'
                            that.grade_id = 4
                        } else if (grade_id == 5) {
                            that.grade = '小学五年级'
                            that.grade_id = 5
                        } else if (grade_id == 6) {
                            that.grade = '小学六年级'
                            that.grade_id = 6
                        }
                        that.getList()
                    }
                }
            })
        },
        getList () {
            let that = this
            this.loading = true
            this.$http.post(API_URL_TASK_API + '/maths/send/quick/knowledge', {
                "grade_id": that.grade_id
            }).then(res => {
                if (res.data.response === 'ok') {
                    that.loading = false
                    if (res.data.data.length) {
                        let data = res.data.data
                        that.getlist = data
                        that.getlist.forEach(function (item) {
                            item.total = 0;
                        })
                    } else {
                        that.no_resources = true
                    }
                }
            })
        },
    },
    destroyed () {

    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px / $ppr;
    height: 200px / $ppr;
    margin-top: -100px / $ppr;
    margin-left: -100px / $ppr;
    background: url("./img/loadingS.gif") no-repeat;
    background-size: 100% 100%;
}

.set {
    display: block;
    margin: 40px / $ppr auto 0;
    width: 360px / $ppr;
    height: 82px / $ppr;
    line-height: 82px / $ppr;
    font-size: 30px / $ppr;
    color: #fff;
    background: #5e89ef;
    border-radius: 41px / $ppr;
    text-align: center;
}

#notice {
    background: #f3f6fd;
    min-height: 100vh;
}

.no_class {
    width: 100%;
    height: auto;
    margin-top: 325px / $ppr;
    text-align: center;
    .icon-shezhijiaocai {
        width: 136px / $ppr;
        height: 112px / $ppr;
        display: inline-block;
        background: url("./img/icon_class.png") no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    p {
        width: 100%;
        text-align: center;
        color: #aaa;
        font-size: 24px / $ppr;
        line-height: 24px / $ppr;
        margin-bottom: 40px / $ppr;
    }
    h3 {
        width: 100%;
        text-align: center;
        color: #333;
        font-size: 36px / $ppr;
        line-height: 36px / $ppr;
        margin: 40px / $ppr 0 16px / $ppr 0;
    }
}

.bottom {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 96px / $ppr;
    font-size: $lg;
    background: #5e89ef;
    color: white;
    text-align: center;
    line-height: 96px / $ppr;
}

.bott {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 96px / $ppr;
    font-size: $lg;
    background: #cccccc;
    color: white;
    text-align: center;
    line-height: 96px / $ppr;
}

.title {
    width: 100%;
    height: 96px / $ppr;
    margin-bottom: 24px / $ppr;
    background: #fff;
    div {
        width: 673px / $ppr;
        height: 96px / $ppr;
        margin: 0 auto;
        p {
            line-height: 96px / $ppr;
            text-align: left;
        }
        p:nth-child(1) {
            width: 34px / $ppr;
            height: 34px / $ppr;
            background: url("img/icon_setbook.png") no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            float: left;
            margin: 31px / $ppr 24px / $ppr 0 0;
        }
        p:nth-child(2) {
            width: 462px / $ppr;
            float: left;
            font-size: 30px / $ppr;
            color: #333;
            @include ellipsis;
        }
        p:nth-child(3) {
            width: 139px / $ppr;
            color: #5e89ef;
            font-size: 30px / $ppr;
            float: left;
        }
        p:nth-child(4) {
            width: 14px / $ppr;
            height: 26px / $ppr;
            float: right;
            margin-top: 34px / $ppr;
            background: url("./img/setGrade.png") no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
        }
    }
}

.content {
    margin-bottom: 100px / $ppr;
    background: white;
    li {
        padding: 30px / $ppr 24px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    li:last-child {
        border-bottom: none;
    }
    ul i,
    em,
    .total {
        width: 50px / $ppr;
        height: 50px / $ppr;
        display: inline-block;
        background-size: 100% 100%;
        float: right;
    }
    .total {
        text-align: center;
        line-height: 1.25rem;
    }
    .icon-jia-hao {
        line-height: 50px / $ppr;
        font-size: 45px / $ppr;
        background-image: url("./img/jiaHao.png");
    }
    .icon-jian-hao {
        background-image: url("./img/jianHao.png");
        line-height: 50px / $ppr;
        font-size: 45px / $ppr;
    }

    span:nth-of-type(1) {
        width: 70%;
        //height: 20px/$ppr;
        font-size: 30px / $ppr;
        color: #333;
        overflow: hidden;
        display: inline-block;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
